import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import "./cinematicAuthMotion.css";

const MotionContext = createContext({ reduced: false, active: true });
export const useCinematicMotion = () => useContext(MotionContext);

export function MotionProvider({ children }) {
  const [reduced, setReduced] = useState(false);
  const [active, setActive] = useState(() => document.visibilityState !== "hidden");
  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const sync = () => setReduced(media.matches);
    const visibility = () => setActive(document.visibilityState !== "hidden");
    sync();
    media.addEventListener?.("change", sync);
    document.addEventListener("visibilitychange", visibility);
    return () => {
      media.removeEventListener?.("change", sync);
      document.removeEventListener("visibilitychange", visibility);
    };
  }, []);
  const value = useMemo(() => ({ reduced, active }), [reduced, active]);
  return <MotionContext.Provider value={value}>{children}</MotionContext.Provider>;
}

export function AuthMotionScene({ children, className = "" }) {
  const { reduced, active } = useCinematicMotion();
  return <div className={`clikkle-auth-motion ${reduced ? "is-reduced" : ""} ${active ? "is-active" : "is-paused"} ${className}`}>{children}</div>;
}

export function StepTransition({ children, step }) {
  return <div key={step} className="clikkle-auth-step">{children}</div>;
}
